import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import LanguagSwitcher from "./LanguageSwitcher";
import kolibrianimation from "../images/kolibri-animation.gif";
import kolibri_sound from "../assets/kolibri-sound.mp3";
import kolibri from "../images/kolibri 1.png";
import { useTranslation } from "react-i18next";
import NavLinks from "./NavLinks";
import { useLocation } from "react-router-dom";

export default function Header() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const audioRef = useRef(null);
  const headerRef = useRef(null);
  const { t } = useTranslation();

  const location = useLocation();

  useEffect(() => {
    if (isHovering) {
      audioRef.current?.play().catch(() => {});
    } else {
      audioRef.current?.pause();
      if (audioRef.current) audioRef.current.currentTime = 0;
    }
  }, [isHovering]);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        headerRef.current.classList.toggle("active", window.scrollY > 100);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Funktion zum Erstellen der Link-URLs
  const getLinkTo = (hash) => {
    // Wenn auf Startseite, dann nur Hash (z.B. "#about")
    // Sonst: Pfad zur Startseite + Hash ("/#about")
    return location.pathname === "/" ? hash : `/#${hash.replace("#", "")}`;
  };

  const navLinks = [
    getLinkTo(`#${t("link-about").toLowerCase()}`),
    getLinkTo(`#${t("link-profile").toLowerCase()}`),
    getLinkTo(`#${t("link-projects").toLowerCase()}`),
    getLinkTo(`#${t("link-contact").toLowerCase()}`),
  ];

  // Positionen für den Kolibri bei Hover (angepasst auf Links)
  const handleHover = (target) => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) return; // Auf mobilen Geräten keine Animation

    setIsHovering(true);
    const positions = {
      [getLinkTo(`#${t("link-about")}`)]: { x: window.innerWidth - 500, y: 35 },
      [getLinkTo(`#${t("link-profile")}`)]: {
        x: window.innerWidth - 400,
        y: 35,
      },
      [getLinkTo(`#${t("link-projects")}`)]: {
        x: window.innerWidth - 320,
        y: 35,
      },
      [getLinkTo(`#${t("link-contact")}`)]: {
        x: window.innerWidth - 220,
        y: 35,
      },
    };
    setPosition(positions[target] || { x: 0, y: 0 });
  };

  const resetPosition = () => {
    setIsHovering(false);
    setPosition({ x: 0, y: 0 });
  };

  return (
    <header className="header" ref={headerRef}>
      <LanguagSwitcher />
      <Link to="/" aria-label="Zur Startseite">
        <motion.img
          src={
            window.innerWidth < 768
              ? kolibri
              : isHovering
              ? kolibrianimation
              : kolibri
          }
          alt="Kolibri"
          animate={{ x: position.x, y: position.y }}
          transition={{ type: "spring", stiffness: 100, damping: 15 }}
          className="kolibri-animation"
          style={{ cursor: "pointer" }}
        />
      </Link>

      <audio ref={audioRef} src={kolibri_sound} />
      <button
        className={`burger-button${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Menu"
      >
        <span className="line" />
        <span className="line" />
        <span className="line" />
      </button>
      <nav className="desktop-nav">
        <NavLinks
          links={navLinks}
          onHover={handleHover}
          onLeave={resetPosition}
        />
      </nav>
      {menuOpen && (
        <nav className="mobile-menu">
          <NavLinks
            links={navLinks}
            onLinkClick={() => setMenuOpen(false)}
            onHover={handleHover}
            onLeave={resetPosition}
          />
        </nav>
      )}
    </header>
  );
}
